import React from 'react';

/**
 * A turned-off form (Paper GSQ-0 "Form unavailable"): one centred line in a
 * plain card — no icon, no admin wording such as the form's internal name.
 */
function FormUnavailable() {
  return (
    <div className="container mx-auto h-full max-w-md items-center py-[var(--cs-space-6)]">
      <p
        role="status"
        className="m-0 box-border rounded-[var(--cs-card-radius)] border border-[color:var(--cs-border-control)] bg-[color:var(--cs-surface-0)] p-[var(--cs-space-6)] text-center font-sans text-[length:var(--cs-text-base)] leading-[var(--cs-leading-24)] font-normal text-[color:var(--cs-text-secondary)] shadow-[shadow:var(--cs-card-shadow)]"
      >
        This form is unavailable.
      </p>
    </div>
  );
}

export default FormUnavailable;
